'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeAddress = exports.getAddressDetails = exports.searchAddress = undefined;

var _client = require('../../utils/client');

var _everydayhero = require('./everydayhero');

var _justgiving = require('./justgiving');

/**
 * @function search an address
 */
var searchAddress = exports.searchAddress = function searchAddress(query, region) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.searchAddress)(query, region) : (0, _everydayhero.searchAddress)(query, region);
};

/**
 * @function get address details
 */
var getAddressDetails = exports.getAddressDetails = function getAddressDetails(id, region) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.getAddressDetails)(id, region) : (0, _everydayhero.getAddressDetails)(id, region);
};

/**
 * @function deserialize an address
 */
var deserializeAddress = exports.deserializeAddress = function deserializeAddress(address) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeAddress)(address) : (0, _everydayhero.deserializeAddress)(address);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/address/index.js
// module id = 1311
// module chunks = 0